import React from 'react';
import wrapSvgPath from './wrapSvgPath';

const pushIconPath = (
  <path id="push_notification" fill="#c5c5c5" d="M21.269 15.972l-2.234-2.234V9.931a8.336 8.336 0 0 0-7.448-8.276V0H9.931v1.655a8.4 8.4 0 0 0-7.448 8.276v3.807L.248 15.972a.751.751 0 0 0-.248.58v2.483a.816.816 0 0 0 .745.828h5.876a4.138 4.138 0 0 0 8.276 0h5.793a.816.816 0 0 0 .828-.745v-2.566a.751.751 0 0 0-.249-.58zm-10.51 6.372a2.438 2.438 0 0 1-2.483-2.483h4.966a2.438 2.438 0 0 1-2.483 2.484zm9.1-4.138H1.655v-1.323l2.235-2.235a.751.751 0 0 0 .248-.579V9.931a6.621 6.621 0 1 1 13.241 0v4.138a.751.751 0 0 0 .248.579l2.234 2.234z"/>
);

export default wrapSvgPath(pushIconPath, '0 0 24 24');
